module.exports = __webpack_public_path__ + "img/image_not_available.3fe9c8a1.jpeg";